/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Menu_Leveling_DescInputs */



/**
* | output |
* | --- |
* | "XP, levels and roles your members chase" |
*
* @param {Products_Menu_Leveling_DescInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_menu_leveling_desc = /** @type {((inputs?: Products_Menu_Leveling_DescInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Menu_Leveling_DescInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("XP, уровни и роли, ради которых стараются участники")
	return /** @type {LocalizedString} */ ("XP, levels and roles your members chase")
});